export default "__VITE_ASSET__DwB2bZU0__"